import { render, staticRenderFns } from "./scanner.vue?vue&type=template&id=38f16fe6&"
import script from "./scanner.vue?vue&type=script&lang=js&"
export * from "./scanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports